import {
  FAILURE,
  RESET,
  CHILDSUCCESS,
  RELOADING,
  FIELDPENDING,
  FIELDSUCCESS,
  USERFIELDPENDING,
  USERFIELDSUCCESS,
  AUTOFIELDPENDING,
  AUTOFIELDSUCCESS,
  AUTOFIELDVALUEPENDING,
  AUTOFIELDVALUESUCCESS,
  FILTERFIELDPENDING,
  FILTERFIELDSUCCESS,
  SEARCHFILTERFIELDPENDING,
  SEARCHFILTERFIELDSUCCESS,
} from '../../constants'
import {useReducer} from 'react'

const initialState = {
  entities: {
    entities_details: [
      {
        id: null,
        fields: [],
        filters: [],
        auto_update_fields: [],
        user_update_fields: [],
      },
    ],
  },
  error: null,
  isLoading: false,
  isFieldLoading: false,
  isFilterLoading: false,
  isAutoFieldLoading: false,
  isAutoFieldValueLoading: false,
  isUserFieldLoading: false,
}

const removeDuplicates = (myArr, prop) => {
  return myArr.filter((obj, pos, arr) => {
    return arr.map(mapObj => mapObj[prop].toString()).indexOf(obj[prop].toString()) === pos
  })
}

const getFilterUniqueValueByType = (filter, searchFilters) => {
  if (filter.field_type === 'StatusField') {
    let statusFieldValues = removeDuplicates([...filter.values, ...searchFilters.values], 1)
    return statusFieldValues.sort(function(a, b) {
      var textA = a[0].toUpperCase()
      var textB = b[0].toUpperCase()
      return textA < textB ? -1 : textA > textB ? 1 : 0
    })
  } else if (filter.field_type === 'EntityListField') {
    let entityListFieldValues = [...filter.values, ...searchFilters.values].filter(
      (obj, pos, arr) => {
        return arr.map(mapObj => mapObj[1].$oid).indexOf(obj[1].$oid) === pos
      }
    )
    return entityListFieldValues.sort(function(a, b) {
      var textA = a[0].toUpperCase()
      var textB = b[0].toUpperCase()
      return textA < textB ? -1 : textA > textB ? 1 : 0
    })
  } else if (filter.field_type === 'MultipleListField') {
    let multipleListFieldValues = removeDuplicates([...filter.values, ...searchFilters.values], 0)
    return multipleListFieldValues.sort(function(a, b) {
      var textA = a.toUpperCase()
      var textB = b.toUpperCase()
      return textA < textB ? -1 : textA > textB ? 1 : 0
    })
  }
}

const mergeSearchFilter = (filters, searchFilters) => {
  let myArr = removeDuplicates([...filters, ...searchFilters], 'field_id')
  myArr.map((filter, index) => {
    const searchFilterIndex = searchFilters.findIndex(f => {
      return f.field_id === filter.field_id
    })
    if (searchFilterIndex !== -1) {
      let uniqueValue = getFilterUniqueValueByType(filter, searchFilters[searchFilterIndex])
      myArr[index].values = uniqueValue
    }
    return true
  })
  return myArr
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FIELDPENDING:
      return {
        ...state,
        isFieldLoading: true,
        error: null,
      }
    case FIELDSUCCESS:
      state.entities.entities_details[0].id = action.payload.id
      state.entities.entities_details[0].fields = action.payload.fields
      return {
        ...state,
        isFieldLoading: false,
      }
    case USERFIELDPENDING:
      return {
        ...state,
        isUserFieldLoading: true,
        error: null,
      }
    case USERFIELDSUCCESS:
      state.entities.entities_details[0].user_update_fields = action.payload
      return {
        ...state,
        isUserFieldLoading: false,
      }
    case AUTOFIELDPENDING:
      return {
        ...state,
        isAutoFieldLoading: true,
        error: null,
      }
    case AUTOFIELDSUCCESS:
      state.entities.entities_details[0].auto_update_fields = action.payload
      return {
        ...state,
        isAutoFieldLoading: false,
      }
    case AUTOFIELDVALUEPENDING:
      return {
        ...state,
        isAutoFieldValueLoading: true,
        error: null,
      }
    case AUTOFIELDVALUESUCCESS:
      state.entities.entities_details[0].auto_update_fields_values = action.payload
      return {
        ...state,
        isAutoFieldValueLoading: false,
      }
    case FILTERFIELDPENDING:
      return {
        ...state,
        isFilterLoading: true,
        error: null,
      }
    case FILTERFIELDSUCCESS:
      state.entities.entities_details[0].filters = action.payload
      return {
        ...state,
        isFilterLoading: false,
      }
    case SEARCHFILTERFIELDPENDING:
      return {
        ...state,
        isFilterLoading: true,
        error: null,
      }
    case SEARCHFILTERFIELDSUCCESS:
      state.entities.entities_details[0].filters = action.payload
      return {
        ...state,
        isFilterLoading: false,
      }
    case RELOADING:
      state.entities.entities_details[0].filters = []
      state.entities.entities_details[0].auto_update_fields = []
      state.entities.entities_details[0].user_update_fields = []
      return {
        ...state,
        isFilterLoading: true,
        isAutoFieldLoading: true,
        isAutoFieldValueLoading: true,
        isUserFieldLoading: true,
      }
    case CHILDSUCCESS:
      if (action.payload.filter_details && action.payload.filter_details.filters.length > 0) {
        action.payload.filter_details.filters.map(field => {
          const indexOfEntityChild = state.entities.entities_details[0].auto_update_fields.findIndex(
            f => {
              return f.field_id === field.field_id
            }
          )
          state.entities.entities_details[0].auto_update_fields[indexOfEntityChild] = field
          return true
        })
      }
      return {
        ...state,
      }
    case RESET:
      return {
        isLoading: false,
        error: null,
        entities: {
          entities_details: [
            {
              id: null,
              fields: [],
              filters: [],
              auto_update_fields: [],
              user_update_fields: [],
            },
          ],
        },
      }
    case FAILURE:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
        isFieldLoading: false,
        isFilterLoading: false,
        isAutoFieldLoading: false,
        isAutoFieldValueLoading: false,
        isUserFieldLoading: false,
      }
    default:
      return state
  }
}

const useEntityReducer = () => {
  return useReducer(reducer, initialState)
}

export default reducer
export {useEntityReducer}
